import { render } from "./AfgerondTeam.vue?vue&type=template&id=273043ef&scoped=true"
import script from "./AfgerondTeam.vue?vue&type=script&lang=js"
export * from "./AfgerondTeam.vue?vue&type=script&lang=js"

import "./AfgerondTeam.vue?vue&type=style&index=0&id=273043ef&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273043ef"]])

export default __exports__